import { CompanyConfiguration } from "src/app/ui/models/domains/pbm/companies/company-configuration";
import { AbstractParser } from "../../parser";

export class CompanyConfigurationParser extends AbstractParser<CompanyConfiguration> {
  parse(payload: any): CompanyConfiguration {
    const companyConfiguration = new CompanyConfiguration();
    companyConfiguration.setId(payload.Id);
    companyConfiguration.setFiscalNumber(payload.FiscalNumber);
    companyConfiguration.setTransactionalLimit(payload.TransactionalLimit);
    companyConfiguration.setChangedByExternalUserId(payload.ChangedByExternalUserId);
    companyConfiguration.setCreateDate(payload.CreateDate);
    companyConfiguration.setLastChangeDate(payload.LastChangeDate);
    companyConfiguration.setHasTransactionalLimit(payload.hasTransactionalLimit);
    return companyConfiguration;
  }
}
